import { type RefObject, useEffect, useRef } from "react";

import { useDismiss } from "../../components/useDismiss";

/** Le pointeur est-il hors de la fenêtre surgissante ? Un appui dans la liste d'un `Select` (rendue dans un
 *  portail, `role="listbox"`) appartient au formulaire de la fenêtre : il ne la ferme pas. */
export function isOutsidePopover(
  target: { closest?: (selector: string) => unknown } | null,
  container: { contains: (node: never) => boolean } | null,
): boolean {
  if (!target || !container) return false;
  if (container.contains(target as never)) return false;
  return !target.closest?.('[role="listbox"]');
}

/** Fenêtre surgissante à formulaire (génération MEL/MIL, rôle du poste) : Échap la ferme par la pile partagée
 *  (`useDismiss` : un appui ne ferme qu'elle), un appui hors d'elle et de son bouton aussi — sauf dans la liste
 *  d'un `Select` qu'elle contient. `ref` : conteneur du bouton et de la fenêtre. */
export function usePopover(open: boolean, onClose: () => void, ref: RefObject<HTMLElement | null>): void {
  useDismiss(open, onClose);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (isOutsidePopover(e.target as Element | null, ref.current)) close.current();
    };
    document.addEventListener("pointerdown", onDown);
    return () => document.removeEventListener("pointerdown", onDown);
  }, [open, ref]);
}
